import { useQuery } from '@tanstack/react-query'
import { isSaasApp } from '@/app/flavor'
import { settingsApi, type GeneralSettings } from '@/lib/api/misc'

export function useGeneralSettings() {
  return useQuery<GeneralSettings>({
    queryKey: ['general-settings'],
    queryFn: async () => {
      const res = await settingsApi.get()
      return res.data as GeneralSettings
    },
    staleTime: 60_000,
  })
}

export function usePrintMethod(): 'agent' | 'browser' {
  const { data } = useGeneralSettings()
  if (data?.print_method === 'browser') return 'browser'
  if (data?.print_method === 'agent') return 'agent'
  return isSaasApp() ? 'browser' : 'agent'
}
